angular.module('impactx.cancellation').controller('CRHPurchaserListCtrl', CRHPurchaserListCtrl);

CRHPurchaserListCtrl.$inject = ['selectedListItems'];

function CRHPurchaserListCtrl(selectedListItems)
{
    var self = this;

    self.getDetailLink = function () {
        return 'crhdetails/' + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: self.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'PurchaseOrderView'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/cancellation/templates/crhlistpurchaser.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/cancellationrequest/list/purchaser',
        id: "crhlistpurchaser",
        excelExport: true,
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}